import type { ORGANIZATIONS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    organization: keyof typeof ORGANIZATIONS;
    teamLeaderId: string;
};

export const schemaUserResolver_GetAdvisersWithoutTeam = z.array(
    UsersTableDefinitionZod.pick({
        firstName: true,
        id: true,
        lastName: true,
        role: true,
    }),
);

export type SchemaUserResolver_GetAdvisersWithoutTeam = z.infer<typeof schemaUserResolver_GetAdvisersWithoutTeam>;

export type UserResolver_GetAdvisersWithoutTeam = Resolver<Arguments, SchemaUserResolver_GetAdvisersWithoutTeam>;
